<template>
  <div class="concentrator-content" v-loading="loading">
    <el-button
      type="primary"
      @click="openEditWin('create')"
      >添加</el-button
    >
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column prop="name" label="名称"> </el-table-column>
      <el-table-column prop="number" label="编号"> </el-table-column>
      <el-table-column prop="longitude" label="经度"> </el-table-column>
      <el-table-column prop="latitude" label="经度"> </el-table-column>
      <el-table-column
        prop="stg_name"
        label="当前策略"
        align="center"
      ></el-table-column>
      <el-table-column prop="type" label="型号">
        <template slot-scope="scope">
          {{typeArr[scope.row.type]}}
        </template>
      </el-table-column>
      <el-table-column prop="type" label="回路控制">
        <template slot-scope="scope">
          <el-button type="primary" @click="openLampLoop(scope.row)" round>回路控制</el-button>
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        prop="ste"
        width="140"
        align="center"
        v-if="pageInfo.lamp_protocol!='2'"
        sortable
      >
        <template slot-scope="scope">
          <i :class="steColorType[scope.row.ste]"></i>
          <span>{{ steType[scope.row.ste] }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="edit" label="编辑" width="100">
        <template slot-scope="scope">
          <div class="edit-button">
            <i
              @click="openEditWin(scope.row)"
              class="el-icon-edit pointer mar-r10"
            ></i>
            <i
              class="el-icon-delete pointer"
              @click="delItem(scope.row.id)"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? '添加' : '修改'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        label-width="100px"
        :rules="editOneRule"
      >
        <div class="user-info">
          <el-form-item label="集中器名称" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>
          <el-form-item label="集中器编号" prop="number">
            <el-input v-model="editOne.number"></el-input>
          </el-form-item>
          <el-form-item label="集中器型号" prop="type">
            <el-radio-group v-model="editOne.type">
              <el-radio :label="1">TH6500</el-radio>
              <el-radio :label="2">TH6600</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="map-container">
            <el-amap
              ref="map"
              vid="amap"
              :center="myMap.center"
              :zoom="myMap.zoom"
              :plugin="myMap.plugin"
              class="amap-demo"
              mapStyle="amap://styles/light"
              :events="myMap.events"
            >
              <el-amap-circle-marker
                :center="myMap.markercenter"
                :radius="myMap.radius"
                fillColor="gray"
                strokeColor="#fff"
                :fillOpacity="myMap.fillOpacity"
              >
              </el-amap-circle-marker>
            </el-amap>
          </div>
          <el-form-item label="经度" prop="longitude">
            <el-input v-model="editOne.longitude"></el-input>
          </el-form-item>
          <el-form-item label="纬度" prop="latitude">
            <el-input v-model="editOne.latitude"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!--回路控制-->
    <el-dialog
      class="dialog800"
      :title="'['+lampLoop.name +']回路控制'"
      :visible.sync="lampLoop.dialogVisible"
      v-if="lampLoop.dialogVisible"
    >
      <concentrator-loop
        ref="lampLoop"
        :id="lampLoop.id"
        @closeMethod="closeLampLoop"
      ></concentrator-loop>
    </el-dialog>
  </div>
</template>

<script>
import concentratorApi from "@/api/light/concentrator";
import store from '@/store'
import concentratorLoop from "@/components/light/concentratorLoop";
export default {
  components: {
    concentratorLoop
  },
  data() {
    const vm = this;
    return {
      myMap: {
        center: store.state.user.account.center,
        markercenter: store.state.user.account.center,
        events: {
          mapmove: () => {
            this.handleMove();
          },
        },
        zoom: 18,
        radius: 10,
        fillOpacity: 1,
      },
      loading: false,
      dialogVisible: false,
      typeArr: ['','TH6500','TH6600'],
      steType: ["离线", "在线"],
      steColorType: ["valuered", "valuegreen"],
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
      },
      cnt_all: 0,
      editOneRule: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      editType: -1,
      devSelect: [],
      editOne: {
        name: '',
        number: '',
        sim: '',
        type: '1',
        longitude: '',
        latitude: ''
      },
      lampLoop: {
        id: null,
        dialogVisible: false,
        name: ''
      }
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      concentratorApi.concentratorList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          name: '',
          number: '',
          type: 1,
          longitude: '',
          latitude: ''
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          name: index.name,
          number: index.number,
          type: index.type,
          longitude:index.longitude,
          latitude:index.latitude,
        };

        let lng = index.longitude
        let lat = index.latitude
        let lngLat = [lng, lat]
        if(!lng&&!lat){
          lngLat = store.state.user.account.center
        }
        
        this.myMap.center = lngLat
        this.myMap.markercenter = lngLat

        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      concentratorApi.concentratorEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      concentratorApi.concentratorAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          concentratorApi.concentratorDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleMove() {
      this.myMap.markercenter = this.$refs.map.$$getCenter();
      this.editOne.longitude = this.myMap.markercenter[0];
      this.editOne.latitude = this.myMap.markercenter[1];
    },
    // 回路控制
    openLampLoop(row) {
      this.lampLoop = {
        id: row.id,
        dialogVisible: true,
        name: row.name
      }
    },
    closeLampLoop() {
      this.lampLoop = {
        id: null,
        dialogVisible: false,
        name: ''
      }
    },
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  }
};
</script>
<style lang='less' scoped>
.concentrator-content {
  width: 100%;
}
.map-container {
  padding-left: 100px;
  height: 180px;
  margin-bottom: 10px;
}
</style>